import { render } from "./ShowcaseDizaym.vue?vue&type=template&id=27a384d2"
import script from "./ShowcaseDizaym.vue?vue&type=script&lang=js"
export * from "./ShowcaseDizaym.vue?vue&type=script&lang=js"

import "./ShowcaseDizaym.vue?vue&type=style&index=0&id=27a384d2&lang=css"
import "./ShowcaseDizaym.vue?vue&type=style&index=1&id=27a384d2&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-showcase/leadsbroker-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__